export default __webpack_public_path__ + "static/media/loa_banner.6867162d.jpeg";